import React, {useEffect, useState} from "react";
import "./Loading.scss";
import {useLoading} from "../../context/LoadingContext";

const Loading = () => {
    const {loading} = useLoading();
    const [currentClass, setCurrentClass] = useState<string>('');

    useEffect(() => {
        if (loading) {
            setCurrentClass('show');
        } else {
            setCurrentClass('')
        }
    }, [loading]);

    return (
        <>
            <div className={`loading-wrapper ${currentClass}`}>
                <div className='loading-bar'>
                    <div className='loader-bar'></div>
                </div>
            </div>
        </>
    );
}

export default Loading;
